module.exports = __webpack_public_path__ + "img/p2.330d0eba.jpg";